module.exports = __webpack_public_path__ + "img/icn_accept.9daaec29.svg";